/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import store from '@/store/store.js';


const navMenuItems = [
  {
    url: "/user/dashboard",
    name: "Dashboard",
    slug: "dashboard",
    icon: "GridIcon",
  },
  {
    header: 'Boards',
    icon: 'PackageIcon',
    i18n: 'Boards',
    items: []
  },
  /*{
    header: 'Settings',
    icon: 'PackageIcon',
    i18n: 'Settings',
    items: [
      {
        url: "/user/settings",
        name: "Settings",
        slug: "settings",
        icon: "SettingsIcon",
      }
    ]
  },*/
  // {
  //   header: 'Apps',
  //   icon: 'PackageIcon',
  //   i18n: 'Apps',
  //   items: [
  //     {
  //       url: "/editor/about",
  //       name: "Resume Editor",
  //       slug: "editor",
  //       icon: "LayoutIcon",
  //     },
  //     {
  //       url: "/parser",
  //       name: "Resume Parser",
  //       slug: "parser",
  //       icon: "AlignLeftIcon",
  //     },
  //     {
  //       url: "/editor/personality",
  //       name: "Career Lab",
  //       slug: "career-lab",
  //       icon: "ZapIcon",
  //     }
  //   ]
  // },
  {
    header: 'Reports',
    icon: 'PackageIcon',
    i18n: 'Report',
    items: []
  },
];

export default navMenuItems;
